import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'nanDefault'
})
export class NanDefaultPipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
